<div class="hero-visual">

  <div class="visual-glow" aria-hidden="true"></div>

  <div class="mockup-window dark-theme">

    <div class="mockup-header">
      <div class="mockup-dots">
        <span class="dot dot-red"></span>
        <span class="dot dot-yellow"></span>
        <span class="dot dot-green"></span>
      </div>

      <div class="mockup-title">panel-rendimiento.xlsx</div>

      <div class="sync-status">
        <span class="sync-led"></span> En línea
      </div>
    </div>

    <div class="mockup-body">

      <!-- CHART -->
      <div class="pro-chart-widget">

        <div class="chart-metrics-row">

          <div class="metric-block">
            <span class="metric-value">+248%&nbsp;</span>
            <span class="metric-label">más visibilidad de tu negocio</span>
          </div>

          <div class="metric-block">
            <span class="metric-value">142h/mes&nbsp;</span>
            <span class="metric-label">de tiempo ahorrado gracias a los automatismos</span>
          </div>

        </div>

        <div class="svg-chart-container">
          <svg viewBox="0 0 300 75" class="animated-chart">

            <g stroke="#334155" stroke-dasharray="3,3" opacity="0.25">
              <line x1="0" y1="22" x2="300" y2="22" />
              <line x1="0" y1="48" x2="300" y2="48" />
            </g>

            <path d="M0,62 C 60,58 120,45 180,30 C 230,18 270,22 300,12 L300,75 L0,75 Z"
              fill="rgba(20,184,166,0.15)" />

            <path d="M0,62 C 60,58 120,45 180,30 C 230,18 270,22 300,12"
              fill="none" stroke="#14b8a6" stroke-width="2" />

            <path d="M0,68 C 50,62 100,42 150,28 C 200,12 250,18 300,4 L300,75 L0,75 Z"
              fill="rgba(59,130,246,0.12)" />

            <path d="M0,68 C 50,62 100,42 150,28 C 200,12 250,18 300,4"
              fill="none" stroke="#3b82f6" stroke-width="2.5" />

          </svg>
        </div>

      </div>

      <!-- TABLE -->
      <div class="spreadsheet-widget">

        <div class="sheet-row">
          <div class="sheet-left">Empresas Villarrobledo</div>
          <div class="sheet-right">Menos carga manual</div>
        </div>

        <div class="sheet-row">
          <div class="sheet-left">Negocios El Provencio</div>
          <div class="sheet-right">Más visibilidad</div>
        </div>

        <div class="sheet-row">
          <div class="sheet-left">Comercios San Clemente</div>
          <div class="sheet-right">Optimización continua</div>
        </div>

      </div>

    </div>
  </div>
</div>